import React from 'react';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import { useSelector } from 'react-redux';

import '../home/Home.css';

const Movement = (props) => {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });
    const friendly_url = sessionSelector.pdc_project_friendly_url;

    const pdc_principal_id = sessionSelector.pdc_principal_id_movements || null;

    const paths = {
        endpoint: config.endpoints.backend + 'portal/getallmovements'
    };

    const list = {
        labelTitle: 'Movimentações',
        icon: 'fa-sitemap',
        filter: {
            friendly_url,
            pdc_principal_id
        },
        columns: [
            {
                name: 'principal',
                label: 'Nome do Dirigente'
            },
            {
                name: 'movement_type',
                label: 'Tipo'
            },
            {
                name: 'movement_date',
                label: 'Data de Movimentação'
            }
        ]
    };

    return (
        <div style={{ marginLeft: '35px' }}>
            <CustomListContainer
                canAdd={false}
                labelTitle={list.labelTitle}
                icon={list.icon}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
};

export default Movement;
